<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, nextTick, watch } from "vue";
import MyLog, { LogMessage } from "@/log";

const logs = ref<LogMessage[]>([]);

onMounted(() => {
  logs.value = MyLog.Current.getLogMessages();
});
</script>
<template>
  <v-card style="text-align: center">
    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th>Timestamp</th>
            <th>Type</th>
            <th>Message</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(log, index) in logs" :key="index">
            <td>{{ log.timestamp.toLocaleTimeString() }}</td>
            <td>
              {{ log.type > 1 ? "error" : log.type === 1 ? "warning" : "info" }}
            </td>
            <td class="message-cell">{{ log.message }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-card>
</template>
<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
th,
td {
  padding: 12px 15px;
  border: 1px solid #eee;
}
th {
  background-color: #f4f4f4;
}
.table-container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

table {
  width: 100%;
  border-collapse: collapse;
}

td,
th {
  padding: 8px;
}
.message-cell {
  text-align: left;
}
</style>
